export const FeaturesList = {
  BetaToggle: 'beta_toggle',
  BlockCopyPaste: 'block_copy_paste',
  CreateSpaceTemplate: 'create_space_template',
  ExtendedCustomizer: 'extended_customizer',
  PostTypes: 'post_types',
  Saml: 'saml',
  SearchPageTagFilter: 'search_page_tag_filter',
  SpaceCreationUsingTemplates: 'space_creation_using_templates',
  TotalsAnalytics: 'totals_analytics',
  TranslateButton: 'translate_button',
  PostMassActions: 'post_mass_actions',
  SlateBuilder: 'slate_builder',
  IntercomFederatedSearch: 'intercom_federated_search',
  DynamicBlockSettings: 'dynamic_block_settings',
}
